<div class="brand-container">
  <div class="brand-header">
    <mat-checkbox color="primary" (change)="onSelectAll()"
      matTooltip="{{(isChecked() ? 'common.deselect-all' : 'common.select-all') | translate}}"
      matTooltipPosition="left" [checked]="isChecked()"
      [indeterminate]="isIndeterminate()">
      {{'common.brand' | translate}}
    </mat-checkbox>
  </div>
  <mat-selection-list #brandsList (selectionChange)="onSelectionChange()">
    <mat-list-option color="primary" checkboxPosition="before" *ngFor="let brand of brands"
      [value]="{id: brand.id, name: brand.name}">
      <img class="logo" [src]="brandService.getLogo(brand.logo)" />
    </mat-list-option>
  </mat-selection-list>
</div>